/*
  Recently-viewed: records current product page in localStorage;
  on product + collection + home pages hydrates the .recently-viewed section
  (excluding the current product).
*/
(() => {
  const KEY = 'inkwell:recently-viewed:v1';
  const MAX = 24;

  function readList() {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return [];
      const arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (_) { return []; }
  }
  function writeList(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); } catch (_) {}
  }

  function recordCurrent() {
    const match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    if (!match) return;
    const handle = match[1];
    let list = readList().filter(h => h !== handle);
    list.unshift(handle);
    writeList(list);
  }

  async function hydrate() {
    const sections = document.querySelectorAll('.recently-viewed[data-section-id]');
    if (!sections.length) return;

    const currentMatch = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    const currentHandle = currentMatch ? currentMatch[1] : null;

    const handles = readList().filter(h => h !== currentHandle);
    if (!handles.length) return;

    sections.forEach(async section => {
      const limit = parseInt(section.getAttribute('data-limit') || '6', 10);
      const pick = handles.slice(0, limit);
      const grid = section.querySelector('.recently-viewed__grid');
      if (!grid) return;

      const fetches = pick.map(h =>
        fetch('/products/' + h + '.js', { credentials: 'same-origin' })
          .then(r => r.ok ? r.json() : null)
          .catch(() => null)
      );
      const results = (await Promise.all(fetches)).filter(Boolean);
      if (!results.length) return;

      grid.innerHTML = '';
      results.forEach(p => {
        const img = p.featured_image
          ? '<img class="recently-viewed__image" src="' + p.featured_image.replace(/"/g, '') + '&width=240" alt="' + (p.title || '').replace(/"/g, '') + '" loading="lazy">'
          : '';
        const li = document.createElement('li');
        li.className = 'recently-viewed__item';
        li.innerHTML = '<a class="recently-viewed__link" href="' + p.url + '">'
          + img
          + '<p class="recently-viewed__name">' + (p.title || '').replace(/[<>&]/g, ch => ({'<':'&lt;','>':'&gt;','&':'&amp;'})[ch]) + '</p>'
          + '</a>';
        grid.appendChild(li);
      });
      section.hidden = false;
    });
  }

  recordCurrent();
  hydrate();
})();
